import { type CurrentUser } from 'Users';
import { type NavigationSectionConfig } from 'NavigationHelpers';
import navigationSectionConfigs from './navigationSectionConfigs';

export function getAvailableNavigationSections(
    $injector: angular.auto.IInjectorService,
    currentUser: CurrentUser,
    sectionsToHide: string[] = [],
): [NavigationSectionConfig[], NavigationSectionConfig[]] {
    const allConfigs = navigationSectionConfigs($injector, currentUser);
    const visibleConfigs = allConfigs.filter(config => {
        if (sectionsToHide.includes(config.name)) return false;

        return config.shouldBeVisible();
    });

    return [visibleConfigs, allConfigs];
}
